

	<fb-product-content-slider-light
	*ngIf="craftStory.length>0"
	[storyPreviewForLight]="craftStory"></fb-product-content-slider-light>

	<fb-product-content-slider-dark
	*ngIf="clusterStory.length>0"
	[storyPreviewForDark]="clusterStory"></fb-product-content-slider-dark>

	<fb-product-content-slider-light
	*ngIf="collabStory.length>0"
	[storyPreviewForLight]="collabStory"></fb-product-content-slider-light>

	<fb-product-content-slider-dark
	*ngIf="artistStory.length>0"
	[storyPreviewForDark]="artistStory"></fb-product-content-slider-dark>


